import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateAccountMemberProfileInformationMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountMemberProfileInformationInput;
}>;

export type UpdateAccountMemberProfileInformationMutationResult = { __typename?: 'Mutation' } & {
  updateAccountMemberProfileInformation?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountMemberProfileInformationPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountMemberProfileInformationDocument = /*#__PURE__*/ gql`
  mutation updateAccountMemberProfileInformation($input: UpdateAccountMemberProfileInformationInput!) {
    updateAccountMemberProfileInformation(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateAccountMemberProfileInformationMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMemberProfileInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMemberProfileInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMemberProfileInformationMutation, { data, loading, error }] = useUpdateAccountMemberProfileInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMemberProfileInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccountMemberProfileInformationMutationResult,
    UpdateAccountMemberProfileInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    UpdateAccountMemberProfileInformationMutationResult,
    UpdateAccountMemberProfileInformationMutationVariables
  >(UpdateAccountMemberProfileInformationDocument, options);
}
export type UpdateAccountMemberProfileInformationMutationHookResult = ReturnType<
  typeof useUpdateAccountMemberProfileInformationMutation
>;
